import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CommonMethodService } from '../common-method.service';
import { ECustomErrorCodes, ELetterAndNoticesTemplates, EnumDiscount, EPaymentOrigin, EPropertyProtectionStatus, ETransactionTypes } from '../enum';
import { ProspectService } from 'src/app/services/operations/prospects.service';
import { FingerprintpopupComponent } from '../fingerprintpopup/fingerprintpopup.component';
import { FingerPrintInitService } from 'src/app/services/fingerPrint/fingerPrintInit.service';
import { DatePipe } from '@angular/common';
import { CustomerService } from 'src/app/services/operations/customer.service';
import { CustomerDataService } from 'src/app/facilityOperations/facOps-customer/customer-data.service';
import { IPaymentModeDetails } from '../models/MerchandiseModel';
import { TransferData } from 'src/app/facilityOperations/facOps-customer/transfer-data';
import { FacOpsDataService } from 'src/app/services/operations/facOpsDataService.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import{interval} from 'rxjs';

@Component({
    selector: 'app-cart-shared',
    templateUrl: './cart-shared.component.html',
    styleUrls: ['./cart-shared.component.scss'],
    standalone: false
})
export class CartSharedComponent implements OnInit {
  datepipe: DatePipe = new DatePipe('en');
  paymentDatailsObj: IPaymentModeDetails = <IPaymentModeDetails>{};
  public loaderIcon: Promise<boolean>;
  NoentriesforLeaseAgreement = false;
  duplicateApiLeaseNo = 0;
  isPaymentZero: boolean = false;
  duplicateRequest: any;
  fingerPrintInit: any;
  defaultDocList = [];
  facilityIdPayment;
  UnitNoPayment;
  leaseNoPayment;
  defaultDocListPayment = [];
  PayRecpNum: number = 0;
  resObjDocument = [];
  charityContribution: any;
  surchargeContributionData: any;
  tenantAutoPayDetails: any;
  receiptNumber = 0;
  paymentSection = false;
  DocumentViewPayment = false;
  disableCartStyle: boolean = false;
  unitNumber;
  makePaymentModel;
  lettersListPayment: any = [];
  facilityWiseMakePayList: any = [];
  saveMakePaymentModel = [];
  miscellaneousSettings = null;
  responseFromApi;
  isSaveAllowance = false;
  cartOrderList = [];
  cartTotal: number = 0;
  Restrictiononcheckpayment: boolean = false;
  cancelCartClicked = false;
  processPayData = {
    Type: EPaymentOrigin.MakePayment,
    AmountTobePaid: 0,
    AmountTobePaidWithoutPD: 0,
    sectionList: [],
    DefaultToCash: false,
    facId: 0,
    facilityName: '',
    isAllowanceApplied: false,
    requireFullPayment: false,
    LeaseNo: null,
    TenantId: null,
    isMerchandiseSalesOnly: false,
    isMovedOut: false,
    currentPeriodTotalAmount: 0,
    isPaymentDistribution: false,
    PrePayPeriod: 0,
    UnitDetails: [],
    SurchargeFees: [],
    TotalTax: 0
  }
  toasterConfig = {
    closeButton: true,
    timeOut: 4500,
    easing: 'ease-out',
    progressBar: true,
    positionClass: 'toast-top-right',
    tapToDismiss: true,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'slideUp'
  };

  private apiStatusInterval = environment.paymentGetCCTStatusInterval;
  private apiMaxWaitTime = environment.paymentMaxWaitTime;
  transactionType = ETransactionTypes.Payment;
  paymentOrigin: number = EPaymentOrigin.MakePayment;
  @ViewChild(FingerprintpopupComponent, { static: true }) FingerprintpopupComponent: FingerprintpopupComponent;
  @Output() hideCustomerSection: EventEmitter<any> = new EventEmitter<any>();
  @Output() emitclosemakePay: EventEmitter<any> = new EventEmitter<any>();
  @Output() emitCartListOnUpdate: EventEmitter<any> = new EventEmitter<any>();
  @Input() facilityID = 0;
  @Input() unitContactData = null;

  constructor(private commonMethod: CommonMethodService,
    private prospectService: ProspectService,
    private customerService: CustomerService,
    private refundService: CustomerDataService,
    private transferdataservice: TransferData,
    private facOpsDataService: FacOpsDataService,
    private toastr: ToastrService,
    public fingerPrintInitService: FingerPrintInitService) { }

  ngOnInit(): void {
  }


  toggleClass(Cls) {
    (document.querySelector('#ContainerMain') as HTMLElement).classList.toggle(Cls);
  }
  @HostListener('click', ['$event']) onClick(eve) {
    if ((document.querySelector('#ContainerMain') as HTMLElement).classList.contains('lft_toggled') && eve.target.localName !== 'a') {
      this.toggleClass('lft_toggled');

    }
  }

  clearCartItems() {
    if (this.cartOrderList.length) {
      this.cartOrderList = [];
    }
  }

  loadCartItems(cartData) {
    if (cartData.length) {
      cartData.map((ele) => {
        if (ele.CartItemType === 1) {
          ele.UnitDetails.MoveInDate = this.commonMethod.getTimeZoneOffSetDate(ele.UnitDetails.MoveInDate);
          let Index = this.cartOrderList.findIndex(o => o.UnitId === ele.UnitId && o.LeaseNo === ele.LeaseNo
            && o.CartItemType === ele.CartItemType);
          if (Index === -1) {
            this.cartOrderList.push(ele);
          } else {
            this.cartOrderList[Index] = ele;
          }
          this.emitCartListOnUpdate.emit(this.cartOrderList);
          if (ele.DonotAcceptCheck) {
            this.Restrictiononcheckpayment = ele.DonotAcceptCheck;
          }
          if (ele.requireFullPayment) {
            this.processPayData.requireFullPayment = true;
          }
          this.processPayData.isPaymentDistribution = ele.isPaymentDistribution;
        }
        this.isSaveAllowance = ele.isSaveAllowance;
      });
      this.calculateTotalCartAmount();
    }
  }

  calculateTotalCartAmount() {
    let unitsTotalCharge = 0;
    let unitsCartList = this.cartOrderList.filter(ele => ele.CartItemType === 1);
    if (unitsCartList.length) {
      unitsTotalCharge = unitsCartList.reduce((sum, ele) => sum + parseFloat(ele.totalCustomerDues), 0);
    }
    this.cartTotal = unitsTotalCharge;
  }

  removeFromCart(cartType, unitId, leaseNo) {
    if (cartType === 1) {
      let Index = this.cartOrderList.findIndex(o => o.UnitId === unitId && o.LeaseNo === leaseNo &&
        o.CartItemType === 1);
      this.cartOrderList.splice(Index, 1);
    }
    this.emitCartListOnUpdate.emit(this.cartOrderList);
    this.calculateTotalCartAmount();
  }


  onCancelCart() {
    this.cancelCartClicked = true;
    this.clearCart();
  }

  clearCart() {
    this.cartOrderList = [];
    this.emitCartListOnUpdate.emit(this.cartOrderList);
    this.calculateTotalCartAmount();
    this.saveMakePaymentModel = [];
    if (this.cancelCartClicked) {
      this.toggleClass('rgt_toggled');
      this.cancelCartClicked = false;
    }
  }

  openRentalPayment() {
    this.isSaveAllowance = false;
    this.responseFromApi = {};
    this.createMakePaymentSaveModel(1);
    if (this.facilityID == 0 || this.facilityID == null) {
      this.facilityID = this.processPayData.facId;
    }
    this.getLettersListForPayment(this.facilityID, this.transactionType);
    if (this.miscellaneousSettings && this.miscellaneousSettings.UserAuthenticationforFinancial) {
      this.FingerprintpopupComponent.openFingerprintModal();
      this.fingerPrintInitService.fingerPrintService.moduleType = 3;
      this.fingerPrintInitService.currrentModule = 1;
      if (this.fingerPrintInitService && this.fingerPrintInitService.fingerPrintInit) {
        this.fingerPrintInitService.fingerPrintInit.startCapture();
      }
      this.fingerPrintInitService.emitCaptureEvent.subscribe((resp) => {
        if (resp && resp.modType == 1) {
          if (resp && resp.caltureResponse && resp.caltureResponse.Success) {
            this.FingerprintpopupComponent.isFingerprintAcquired = true;
            this.FingerprintpopupComponent.initials = '';
            this.FingerprintpopupComponent.pin = '';
            this.FingerprintpopupComponent.fingerPrintAuthModal.hide();
            if (this.fingerPrintInitService && this.fingerPrintInitService.fingerPrintInit) {
              this.fingerPrintInitService.fingerPrintInit.stopCapture();
            }
          } else {
            this.FingerprintpopupComponent.isFingerprintAcquired = false;
            this.FingerprintpopupComponent.fingerprintMessage = resp.caltureResponse.Message;
          }
        }
      });
    }
    (document.querySelector('#ContainerMain') as HTMLElement).classList.remove('rgt_toggled');
  }

  createMakePaymentSaveModel(data) {
    let unitList = [];
    unitList = this.cartOrderList.filter((ele) => ele.CartItemType === 1);
    unitList.forEach((ele) => {
      this.savePaymentModel(ele);
    });

    this.getTotalValueForUnit();

    let facilityIdList = [];
    if (this.saveMakePaymentModel.length > 0) {
      this.saveMakePaymentModel.forEach(item => {
        const index = facilityIdList.findIndex(id => id == item.FacilityId);
        if (index == -1) {
          facilityIdList.push(item.FacilityId);
        }
      });
    }
    let facilityWise = this.groupBy(this.saveMakePaymentModel, (c) => c.FacilityId);
    if (facilityWise.length) {
      facilityIdList.map(id => {
        const ele = facilityWise[id];
        let facilityObj = ele[0];
        let facilityId = facilityObj.FacilityId;
        let facilityName = '';
        let facility = this.cartOrderList.find(o => o.UnitDetails.FacilityID === facilityId);
        if (facility) {
          facilityName = facility.UnitDetails.Name;
        }
        let obj = {
          FacilityId: facilityId,
          FacilityName: facilityName,
          SaveModelList: ele,
          isPaid: false,
          docProcessed: false,
          FacilityTotalAmt: ele.reduce((sum, a) => sum + a.AmountPaidTotal, 0),
          FacilityTotalCurrentPeriodAmt: ele.reduce((sum, a) => sum + a.currentPeriodTotal, 0),
          FacilityTotalAmtWithoutPD: ele.reduce((sum, a) => sum + a.TotalCustomerDuesWithoutPD, 0),
          FacilityTotalTax: ele.reduce((sum, a) => sum + (a.TotalTax || 0), 0)
        }
        this.facilityWiseMakePayList.push(obj);
      });
    }
    if (this.facilityWiseMakePayList.length && data == 1) {
      let unitDataList = [];
      this.facilityWiseMakePayList.forEach((ele) => {
        const data = ele.SaveModelList ? ele.SaveModelList.find((item) => item.LeaseId == 327) : null;
        ele.SaveModelList.forEach((e) => {
          let PaymentDistributionOverride = e.PaymentDistributionOverride ? e.PaymentDistributionOverride : null
          if (PaymentDistributionOverride) {
            PaymentDistributionOverride['IsManualDistribution'] = true;
            PaymentDistributionOverride['IsAuctionProceed'] = false;
          }
          let unitDetails = {
            UnitId: e.UnitId,
            LeaseNo: e.LeaseNo,
            ReservationNo: null,
            UnitNo: e.UnitNo,
            Amount: e.AmountPaidTotal,
            PaymentDistribution: PaymentDistributionOverride
          }
          unitDataList.push(unitDetails);
        });
        this.processPayData.AmountTobePaid = ele.FacilityTotalAmt;
        this.processPayData.AmountTobePaidWithoutPD = ele.FacilityTotalAmtWithoutPD;
        this.processPayData.currentPeriodTotalAmount = ele.FacilityTotalCurrentPeriodAmt;
        this.processPayData.facilityName = ele.FacilityName;
        this.processPayData.facId = ele.FacilityId;
        this.processPayData.TotalTax = this.commonMethod.roundToTwo(ele.FacilityTotalTax || 0);
        this.processPayData.TenantId = this.unitContactData.TenantId;
        this.processPayData.LeaseNo = this.unitContactData.LeaseNo;
        this.processPayData.isMovedOut = data ? true : false;
        this.processPayData.UnitDetails = unitDataList;
        this.processPayData.SurchargeFees = this.cartOrderList.find(o => o.UnitDetails.FacilityID === ele.FacilityId)?.SurchargeFees ?? [];
        this.tenantAutoPayDetails = this.refundService.customerAutoPayDetails;
        this.disableCartStyle = true;
        this.hideCustomerSection.emit(true);
        this.paymentSection = true;
      });
    }
  }

  getLettersListForPayment(facilityId, transactionType) {
    this.prospectService.getLettersByTransactionType(facilityId, transactionType).subscribe((response: any) => {
      this.lettersListPayment = response;
      this.lettersListPayment.map((ele) => {
        ele['selected'] = false;
      });
    });
  }

  getCustomerMiscSettings(facilityId) {
    this.prospectService.getFacilityMiscellaneousSettings(facilityId).subscribe((response) => {
      this.miscellaneousSettings = response;
    });
  }

  savePaymentModel(objectDetails) {
    this.makePaymentModel = objectDetails;
    if (objectDetails.CartItemType === 1) {
      let rentAllowance = this.getRentAllowance(objectDetails.AllowanceList, 2);
      let feeAllowance = this.getRentAllowance(objectDetails.AllowanceList, 4);
      let InsAllowance = this.getRentAllowance(objectDetails.AllowanceList, 3);
      let depositAllowance = this.getRentAllowance(objectDetails.AllowanceList, 1);
      let merchAllowance = this.getRentAllowance(objectDetails.AllowanceList, 5);
      let lateLienAllowance = this.getRentAllowance(objectDetails.AllowanceList, 6);
      this.unitNumber = objectDetails.UnitDetails.UnitNo;
      const allowanceItemId = objectDetails.allowanceItemId; /////

      let amtTotalPaid = 0;
      let amtTotalPaidCurrent = 0;
      this.processPayData.PrePayPeriod = objectDetails.PrePayPeriods;
      amtTotalPaid = this.commonMethod.roundToTwo(objectDetails.totalCustomerDues);
      amtTotalPaidCurrent = this.commonMethod.roundToTwo(objectDetails.currentPeriodTotal);
      const paymentDistOvrRide = {
        Deposit: objectDetails.depositPD,
        Rent: objectDetails.rentPD,
        RentalTax: objectDetails.rentTaxPD,
        Fees: objectDetails.feesPD,
        FeesTax: objectDetails.feesTaxPD,
        Insurance: objectDetails.propProtPD,
        InsuranceTax: objectDetails.propProtTaxPD,
        Merchandise: objectDetails.merchandisePD,
        MerchandiseTax: objectDetails.merchandiseTaxPD,
        LateLienCharges: objectDetails.lateAndlienPD,
        LateLienChargesTax: objectDetails.lateAndlienTaxPD,
        AmountPaidTotal: amtTotalPaid,
      }

      if (objectDetails && objectDetails.AppliedDiscountList) {
        if (objectDetails.AppliedDiscountList.length) {
          objectDetails.AppliedDiscountList.forEach((ele) => {
            if (ele.PeriodStartDateTime) {
              const dateStr = this.datepipe.transform(ele.PeriodStartDateTime, 'MM/dd/yyyy');
              ele.PeriodStartDateTime = dateStr;
            }
            if (ele.StopDate) {
              if (this.commonMethod.isDateInFormat(ele.StopDate)) {
                ele.StopDate = this.commonMethod.getFormattedDate(ele.StopDate);
              } else {
                ele.StopDate = this.datepipe.transform(new Date(ele.StopDate), 'MM/dd/yyyy');
              }
            }
          });
        }
      }
      let appliedDiscounts = null;
      if (objectDetails.IsPaymentDist && objectDetails.IsPaymentDistrDiscountisApplied && objectDetails.AppliedDiscountList.length) {
        appliedDiscounts = objectDetails.AppliedDiscountList.filter((item) => item.CategoryId !== 237);
      } else {
        appliedDiscounts = objectDetails.AppliedDiscountList;
      }
      let saveObj = {
        LeaseNo: objectDetails.LeaseNo,
        FacilityId: objectDetails.UnitDetails.FacilityID,
        UnitNo: objectDetails.UnitDetails.UnitNo,
        UnitId: objectDetails.UnitId,
        PrePayPeriods: objectDetails.PrePayPeriods,
        RentAllowance: parseFloat(rentAllowance).toFixed(2),
        FeeAllowance: parseFloat(feeAllowance).toFixed(2),
        InsAllowance: parseFloat(InsAllowance).toFixed(2),
        DepositAllowance: parseFloat(depositAllowance).toFixed(2),
        MerchAllowance: parseFloat(merchAllowance).toFixed(2),
        LateLienAllowance: parseFloat(lateLienAllowance).toFixed(2),
        AmountPaidTotal: amtTotalPaid,
        TotalCustomerDuesWithoutPD: this.commonMethod.roundToTwo(objectDetails.totalCustomerDuesWithoutPD),
        TotalTax: this.commonMethod.roundToTwo(objectDetails.IsPaymentDist
          ? (objectDetails.rentTaxPD || 0) +
            (objectDetails.feesTaxPD || 0) +
            (objectDetails.propProtTaxPD || 0) +
            (objectDetails.merchandiseTaxPD || 0) +
            (objectDetails.lateAndlienTaxPD || 0)
          : (objectDetails.totalCustomerDuesTax || 0)),
        ModifiedFeesList: objectDetails.FeesChargesList,
        ModifiedDiscountList: appliedDiscounts,
        ModifiedInsuranceDetails: objectDetails.InsuranceDetails,
        LateLienAllowanceList: objectDetails.LateLienAllowanceList,
        MerchandiseSold: null,
        PaymentModeDetails: null,
        AllowanceNotes: objectDetails.allowanceNotes,
        AllowanceItemId: objectDetails.allowanceItemId == 0 ? null : objectDetails.allowanceItemId,
        MerchandiseSalesOnly: false,
        PaymentNote: objectDetails.PaymentNote,
        TransactionType: 2,
        PaymentTransactionType: 2,
        PrcBitOnlineTransaction: false,
        PrcBitDisplayAlert: false,
        PaymentDistributionOverride: objectDetails.IsPaymentDist == true ? paymentDistOvrRide : null,
        LeaseId: objectDetails.UnitDetails.LeaseId,
        currentPeriodTotal: amtTotalPaidCurrent
      };

      let index = this.saveMakePaymentModel.findIndex(o => o.LeaseNo === objectDetails.LeaseNo);
      if (index === -1) {
        this.saveMakePaymentModel.push(saveObj);
      }
    }
  }

  getTotalValueForUnit() {
    this.saveMakePaymentModel.forEach((ele) => {
      if (ele.MerchandiseSold) {
        if (ele.MerchandiseSold.MerchandiseSaleDetails.length) {
          let amountPaidTotal = ele.MerchandiseSold.MerchandiseSaleDetails.reduce((sum, a) => sum + a.Total, 0);
          ele.AmountPaidTotal += amountPaidTotal;
          ele.AmountPaidTotal = this.commonMethod.roundToTwo(ele.AmountPaidTotal);
          ele.TotalCustomerDuesWithoutPD += amountPaidTotal;
          ele.TotalCustomerDuesWithoutPD = this.commonMethod.roundToTwo(amountPaidTotal);
        }
      }
    });
  }

  groupBy(xs, f) {
    return xs.reduce((r, v, i, a, k = f(v)) => ((r[k] || (r[k] = [])).push(v), r), []);
  }

  getRentAllowance(allowanceList, type) {
    if (allowanceList.length) {
      let Obj = allowanceList.find(o => o.AllowanceType === type);
      if (Obj) {
        if (type === 4 || type === 6) {
          let arr = allowanceList.filter((ele) => ele.AllowanceType === type);
          let allowance = arr.reduce((sum, ele) => parseFloat(sum) + parseFloat(ele.Allowance), 0);
          if (allowance > 0) {
            this.processPayData.isAllowanceApplied = true;
          }
          return allowance;
        }
        if (Obj.Allowance > 0) {
          this.processPayData.isAllowanceApplied = true;
        }
        return Obj.Allowance;
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  }

  loopPayment() {
    if (this.PayRecpNum != 0) {
      this.lettersListPayment.map((ele) => {
        if (ele.TemplateId === ELetterAndNoticesTemplates.Payment_Receipt) {
          ele['isProcessed'] = false;
          ele['blobUrl'] = '';
          ele['RecepitNumber'] = this.PayRecpNum;
          if (!this.isPresentInDocList(ele.LetterId)) {
            this.lettersListPayment.push(ele);
            this.defaultDocListPayment.push(ele);
          }
        }
      });
    }
    this.defaultDocListPayment = [];
    this.showDocument();
    this.responseFromApi = {
    };
  }

  showDocument() {
    let leaseId;
    this.facilityIdPayment = this.resObjDocument[0].FacilityId;
    this.leaseNoPayment = this.resObjDocument[0].LeaseNo;
    const data = this.facilityWiseMakePayList.find((item) => item.FacilityId === this.facilityIdPayment).SaveModelList;
    if (data.length == 1) {
      this.UnitNoPayment = data[data.length - 1].UnitNo;
    } else {
      this.UnitNoPayment = data.find((ele) => ele.LeaseNo === this.leaseNoPayment).UnitNo;
    }
    leaseId = data.find((ele) => ele.LeaseNo === this.leaseNoPayment).LeaseId;
    if (this.lettersListPayment.length) {
      this.lettersListPayment.map((item) => {
        if (item.TemplateId === ELetterAndNoticesTemplates.Partial_Payment_Received_Letter) { // Partial Payment Received Letter
          if (this.makePaymentModel.PrePayPeriods == 0 && leaseId !== 327 && this.getAmountPaid(this.paymentDatailsObj) !== 0 &&
            (parseFloat(this.processPayData.AmountTobePaidWithoutPD.toFixed(2)) > this.getAmountPaid(this.paymentDatailsObj))) {
            item['isProcessed'] = false;
            item['blobUrl'] = '';
            this.defaultDocListPayment.push(item);
          }
        } else if (item.TemplateId === ELetterAndNoticesTemplates.Partial_PrePayment_Received_Letter) { // Partial PrePayment Received Letter
          if (this.makePaymentModel.PrePayPeriods > 0 && (parseFloat(this.processPayData.AmountTobePaid.toFixed(2)) > this.getAmountPaid(this.paymentDatailsObj))
            && this.getAmountPaid(this.paymentDatailsObj) !== 0) {
            item['isProcessed'] = false;
            item['blobUrl'] = '';
            this.defaultDocListPayment.push(item);
          }
        } else if (item.TemplateId === ELetterAndNoticesTemplates.Automatic_Credit_Card_Form) { // Automatic Credit Card Form
          item['isProcessed'] = false;
          item['blobUrl'] = '';
          this.defaultDocListPayment.push(item);
        } else if (item.TemplateId === ELetterAndNoticesTemplates.Automatic_ACH_Form) { // Automatic Credit Card Form
          item['isProcessed'] = false;
          item['blobUrl'] = '';
          this.defaultDocListPayment.push(item);
        } else if (item.TemplateId === ELetterAndNoticesTemplates.Insurance_Addendum) { // Insurance Addendum
          if (this.makePaymentModel.InsuranceDetails && this.makePaymentModel.InsuranceDetails.Status == EPropertyProtectionStatus.Insured) {
            item['isProcessed'] = false;
            item['blobUrl'] = '';
            if (!this.isPresentInDocList(item.LetterId)) {
              this.defaultDocListPayment.push(item);
            }
          }
        } else if (item.TemplateId === ELetterAndNoticesTemplates.Insurance_Cancellation_Letter) { // Insurance Cancellation Letter
          if (this.makePaymentModel.initialPPSelected && this.makePaymentModel.InsuranceDetails &&
            this.makePaymentModel.initialPPSelected.Status == EPropertyProtectionStatus.Insured &&
            this.makePaymentModel.InsuranceDetails.Status !== EPropertyProtectionStatus.Insured) {
            item['isProcessed'] = false;
            item['blobUrl'] = '';
            if (!this.isPresentInDocList(item.LetterId)) {
              this.defaultDocListPayment.push(item);
            }
          }
        } else if (item.TemplateId === ELetterAndNoticesTemplates.Payment_Receipt && this.responseFromApi) { // Payment Receipt
          if (this.PayRecpNum != 0) {
            item['isProcessed'] = false;
            item['blobUrl'] = '';
            item['RecepitNumber'] = this.PayRecpNum;
            if (!this.isPresentInDocList(item.LetterId)) {
              this.defaultDocListPayment.push(item);
            }
          } else if (this.PayRecpNum == 0) {
            this.lettersListPayment = this.lettersListPayment.filter((ele) => (ele.TemplateId != ELetterAndNoticesTemplates.Payment_Receipt));
            this.defaultDocListPayment = this.defaultDocListPayment.filter((ele) => (ele.TemplateId != ELetterAndNoticesTemplates.Payment_Receipt));
          }
        }
      });
    }

    if (this.defaultDocListPayment.length) {
      this.DocumentViewPayment = true;
    } else {
      this.cartOrderList = [];
      this.emitCartListOnUpdate.emit(this.cartOrderList);
      this.saveMakePaymentModel = [];
      this.facilityWiseMakePayList = [];
      this.hideCustomerSection.emit(false);
      this.DocumentViewPayment = false;
      this.cartTotal = 0;
      this.defaultDocList = [];
      this.defaultDocListPayment = [];
    }
    this.paymentSection = false;
    this.disableCartStyle = false;
  }

  isPresentInDocList(letterId) {
    const index = this.defaultDocListPayment.findIndex(o => o.LetterId === letterId);
    if (index === -1) {
      return false;
    }
    return true;
  }

  paymentCancel(eve) {
    if (this.resObjDocument.length) {
      this.loopPayment();
    } else {
      this.paymentSection = false;
      this.disableCartStyle = false;
      this.hideCustomerSection.emit(false);
      this.saveMakePaymentModel = [];
      this.facilityWiseMakePayList = [];
      this.onCancelCart();
    }
    (document.querySelector('#ContainerMain') as HTMLElement).classList.remove('rgt_toggled');
  }

  postPayment(paymentData) {
    this.paymentDatailsObj = paymentData[0];
    let saveObj = this.facilityWiseMakePayList.find(o => o.FacilityId === this.processPayData.facId);
    if (saveObj) {
      if (saveObj.SaveModelList.length) {
        saveObj.SaveModelList.forEach((ele) => {
          let payObj;
          if (this.paymentDatailsObj.IsRemotePayTransaction || this.getAmountPaid(this.paymentDatailsObj) !== 0) {
            payObj = {
              CashTransaction: this.paymentDatailsObj.CashTransaction == undefined ? null : this.paymentDatailsObj.CashTransaction,
              CCTransaction: this.paymentDatailsObj.CCTransaction == undefined ? [] : this.paymentDatailsObj.CCTransaction,
              ACHTransaction: this.paymentDatailsObj.ACHTransaction == undefined ? [] : this.paymentDatailsObj.ACHTransaction,
              CheckTransaction: this.paymentDatailsObj.CheckTransaction == undefined ? [] : this.paymentDatailsObj.CheckTransaction,
              DirectDebitTransaction: this.paymentDatailsObj.DirectDebit == undefined ? [] : this.paymentDatailsObj.DirectDebit,
              IsRemotePayTransaction: this.paymentDatailsObj.IsRemotePayTransaction ? true : false,
              RemotePayTransactionId: this.paymentDatailsObj.IsRemotePayTransaction ? this.paymentDatailsObj.RemotePayTransactionId : 0,
              RemotePayTransaction: null,
              RemotePayAmount : this.paymentDatailsObj.RemotePayAmount > 0 ? this.paymentDatailsObj.RemotePayAmount : 0,
            }
          } else {
            payObj = null;
          }
          ele.PaymentModeDetails = payObj;
          ele.AutoPayDetails = this.transferdataservice.pastdueautopay;
        });

        if (this.charityContribution) {
          if (this.charityContribution.IsCharitableFee) {
            saveObj.SaveModelList[0].ModifiedFeesList.push(this.charityContribution)
            saveObj.SaveModelList[0].MerchandiseSalesOnly = false;
            if (saveObj.SaveModelList.length > 1) {
              saveObj.SaveModelList[0].AmountPaidTotal = saveObj.SaveModelList[0].AmountPaidTotal + this.charityContribution.Amount;
              saveObj.SaveModelList[0].TotalCustomerDuesWithoutPD += this.charityContribution.Amount;

            }
          }
        }
        const modifiedFees = saveObj.SaveModelList[0].ModifiedFeesList || [];
        saveObj.SaveModelList[0].ModifiedFeesList = modifiedFees.filter(fee => !fee.IsSurchargeFee);
        if (this.surchargeContributionData?.IsSurchargeFee) {
          saveObj.SaveModelList[0].ModifiedFeesList.push(this.surchargeContributionData);
          saveObj.SaveModelList[0].MerchandiseSalesOnly = false;
          // Server reconciles AmountPaidTotal with this fee after validation (MakePaymentBusiness) - do not fold it in here.
        }

        const amountPaid = this.getAmountPaid(this.paymentDatailsObj);
        const totalAllocatedAmount = this.commonMethod.roundToTwo(
          saveObj.SaveModelList.reduce((sum, item) => sum + (item.AmountPaidTotal || 0), 0)
        );
        const roundingDelta = this.commonMethod.roundToTwo(amountPaid - totalAllocatedAmount);
        const isCashRoundingEnabled = !!(
          this.prospectService?.paymentSettings &&
          this.prospectService.payFacId == this.processPayData.facId &&
          this.prospectService.paymentSettings.EnableCashRounding &&
          this.paymentDatailsObj?.CashTransaction
        );
        // Keep unit allocations intact and apply only the net delta so total allocated equals paid amount.
        // Skipped for a surcharge payment: the server folds the surcharge and its cash rounding in after validation.
        const hasSurchargeFee = (saveObj.SaveModelList[0]?.ModifiedFeesList || []).some(fee => fee.IsSurchargeFee);
        if (isCashRoundingEnabled && !hasSurchargeFee && saveObj.SaveModelList.length > 0 && roundingDelta !== 0) {
          const targetUnit = saveObj.SaveModelList.find((item) => (item.AmountPaidTotal || 0) > 0) || saveObj.SaveModelList[0];
          targetUnit.AmountPaidTotal = this.commonMethod.roundToTwo((targetUnit.AmountPaidTotal || 0) + roundingDelta);
        }
        if (this.processPayData.AmountTobePaid > amountPaid) {
          let remainingAmount = amountPaid;
          saveObj.SaveModelList.forEach((unit) => {
            remainingAmount -= unit.currentPeriodTotal;
          });
          saveObj.SaveModelList.map((item) => {
            const prepayAmount = item.AmountPaidTotal - item.currentPeriodTotal;
            if (item.PrePayPeriods > 0 && remainingAmount < prepayAmount) {
              if (item.ModifiedDiscountList.length) {
                item.ModifiedDiscountList.forEach((discount) => {
                  if (discount.Selected && discount.CategoryId === EnumDiscount.PrePayment) {
                    discount.Selected = false;
                  }
                });
              }
            }
            remainingAmount -= prepayAmount;
          });
        }
        this.saveMakePaymentDetails(saveObj.SaveModelList, 1);
      }
    }
    if (this.fingerPrintInit) {
      this.fingerPrintInit.stopCapture();
    }
  }

  saveMakePaymentDetails(facilityLists, type) {
    this.resObjDocument = [];
    this.loaderIcon = Promise.resolve(true);
    this.customerService.saveCustomerMakePayments(facilityLists).subscribe((response: any) => {
      if (response) {
        if (this.transferdataservice.pastdueautopay) {
          this.transferdataservice.pastdueautopay = null;
        }
        if (this.facOpsDataService.saveautopay && (this.facOpsDataService.saveautopay.Autopay || this.facOpsDataService.saveautopay.ACHPayment)) {
          this.getLettersAutoPay(this.facilityID, this.facOpsDataService.saveautopay.ACHPayment);
          this.facOpsDataService.saveautopay = null;
        }
        this.FingerprintpopupComponent.resetFingerprintOrigin();
        this.loaderIcon = Promise.resolve(false);
        let tempObj = response.PaymentResponses.find(o => o.Success === true);
        if (tempObj) {
          this.resObjDocument.push(tempObj);
          this.resObjDocument.map((item) => item['removeItem'] = false);
        }
        let resObj = response.PaymentResponses.find(o => o.Success === false);
        if (resObj) {
          this.receiptNumber = response.ReceiptNumber;
          this.responseFromApi = {
            ReceiptId: response.ReceiptNumber,
            Date: new Date(),
            Success: false,
            isErrorSection: false,
            AmountPaid: this.getAmountPaid(this.paymentDatailsObj)
          }
          if (type == 2) {
            // this.emitHideMakePay.emit(true);
            this.toastr.error('Failed to save Allowance', 'Error', this.toasterConfig);
          } else {
            this.toastr.error('Failed to save payment', 'Error', this.toasterConfig);
          }
        } else {
          if (response.ReceiptNumber) {
            this.PayRecpNum = response.ReceiptNumber
          }
          let saveObj = this.facilityWiseMakePayList.find(o => o.FacilityId === this.processPayData.facId);
          if (saveObj) {
            saveObj.isPaid = true;
          }
          if (type == 2) {
            // this.emitHideMakePay.emit(true);
            this.toastr.success('Allowance saved successfully', 'Success', this.toasterConfig);
            this.cartOrderList = [];
            this.emitCartListOnUpdate.emit(this.cartOrderList);
            this.saveMakePaymentModel = [];
            this.emitclosemakePay.emit(true);
            this.reloadcustomerinfo();
          } else {
            this.toastr.success('Payment Saved successfully', 'Success', this.toasterConfig);
          }

          this.receiptNumber = response.ReceiptNumber;
          this.responseFromApi = {
            ReceiptId: response.ReceiptNumber,
            Date: new Date(),
            ReceiptURL: response.ReceiptURL,
            Success: true,
            isErrorSection: false
          };
          this.clearCart()
        }
      } else {
        this.loaderIcon = Promise.resolve(false);
        if (type == 2) {
          this.toastr.error('Failed to save allowance', 'Error', this.toasterConfig);
        } else {
          this.toastr.error('Failed to save payment', 'Error', this.toasterConfig);
        }
        this.receiptNumber = 0;
        this.responseFromApi = {
          ReceiptId: 0,
          Date: new Date(),
          Success: false,
          isErrorSection: false,
          AmountPaid: this.getAmountPaid(this.paymentDatailsObj)
        };
      }
    }, err => {
      if (err && err.error && (err.error.error == 'Duplicate Request' || err.error.title == 'Duplicate Request') && err.status == 409) {
        let transactionList = [];
        facilityLists.forEach((ele) => {
          const obj = {
            LeaseNo: ele.LeaseNo,
            FacilityId: ele.FacilityId,
            TransactionType: ele.TransactionType,
            UnitId: ele.UnitId,
            UnitNo: ele.UnitNo,
            PaymentTransactionType: ele.PaymentTransactionType,
            TotalPaid: this.getAmountPaid(this.paymentDatailsObj),
            TotalAllowance: ele.RentAllowance + ele.FeeAllowance + ele.InsAllowance + ele.DepositAllowance + ele.MerchAllowance + ele.LateLienAllowance
          }
          transactionList.push(obj);
        });
        if (this.duplicateRequest == null) {
          const source = interval(this.apiStatusInterval * 1000);
          this.duplicateApiLeaseNo = 0;
          this.duplicateRequest = source.subscribe(val => this.duplicateRequestRetry(transactionList, val, type));
        }
      } else if (err && err.error && err.status == ECustomErrorCodes.SleepingThread && err.error.type == 'Sleeping Thread') {
        this.loaderIcon = Promise.resolve(false);
        this.toastr.error('Your transaction could not be completed as it exceeds the maximum permissible prepay limit', 'Failure', this.toasterConfig);
        let obj = {
          Success: false,
          ReceiptId: 0,
          AmountPaid: this.getAmountPaid(this.paymentDatailsObj),
          isErrorSection: err && (err.status == 0 && err.statusText == "Unknown Error") || (err.status == 504 && err.statusText == "Gateway Timeout") ? true : false
        }
        setTimeout(() => {
          this.responseFromApi = obj;
        }, 1000);
      } else {
        this.loaderIcon = Promise.resolve(false);
        if (type == 2) {
          this.toastr.error('Failed to save allowance', 'Error', this.toasterConfig);
        } else {
          this.toastr.error('Failed to save payment', 'Error', this.toasterConfig);
        }
        this.receiptNumber = 0;
        let obj = {
          ReceiptId: 0,
          Date: new Date(),
          Success: false,
          AmountPaid: this.getAmountPaid(this.paymentDatailsObj),
          isErrorSection: err && (err.status == 0 && err.statusText == "Unknown Error") || (err.status == 504 && err.statusText == "Gateway Timeout") ? true : false
        };
        setTimeout(() => {
          this.responseFromApi = obj;
        }, 1000);
        // this.data.custimerInfoStorage.leaseNo = this.data.selectedLease;
      }
    });
  }

  getLettersAutoPay(facilityId, isAutoACH) {
    this.prospectService.getLettersByTransactionType(facilityId, 1).subscribe((response: any) => {
      response.map((ele) => {
        ele['selected'] = false;
        if (isAutoACH) {
          if (ele.TemplateId == ELetterAndNoticesTemplates.Automatic_ACH_Form) {
            this.lettersListPayment.push(ele);
          }
        } else {
          if (ele.TemplateId == ELetterAndNoticesTemplates.Automatic_Credit_Card_Form) {
            this.lettersListPayment.push(ele);
          }
        }
      });
    });
  }

  charityFeesContribution(eve) {
    this.charityContribution = eve;
  }

  surchargeContributionReceived(eve) {
    this.surchargeContributionData = eve;
  }

  GetAutoPayDetails(leaseNo, facilityId) {
    this.customerService.GetAutoPayDetails(leaseNo, facilityId).subscribe((response: any) => {
      if (response) {
        this.tenantAutoPayDetails = response;
        this.tenantAutoPayDetails['FacilityId'] = facilityId;
        this.tenantAutoPayDetails['LeaseNo'] = leaseNo;
        this.refundService.customerAutoPayDetails = JSON.parse(JSON.stringify(this.tenantAutoPayDetails));
      }
    });
  }

  getAmountPaid(payObj) {
    let amountPaid = 0;
    if (payObj !== null && payObj !== undefined) {
      if (this.paymentDatailsObj.CashTransaction !== undefined) {
        amountPaid += parseFloat(payObj.CashTransaction.Amount);
      }
      if (payObj.CCTransaction) {
        payObj.CCTransaction.forEach((ele) => {
          amountPaid += parseFloat(ele.Amount);
        });
      }
      if (payObj.ACHTransaction) {
        payObj.ACHTransaction.forEach((ele) => {
          amountPaid += parseFloat(ele.Amount);
        });
      }
      if (payObj.CheckTransaction) {
        payObj.CheckTransaction.forEach((ele) => {
          amountPaid += parseFloat(ele.Amount);
        });
      }
      if (payObj.DirectDebitTransaction) {
        payObj.DirectDebitTransaction.forEach((ele) => {
          amountPaid += parseFloat(ele.Amount);
        });
      }
    }
    return amountPaid;
  }

  duplicateRequestRetry(obj, count, type) {
    count = count + 1;
    let maxTime = (this.apiMaxWaitTime * 60) / this.apiStatusInterval;
    if (count <= maxTime) {
      this.customerService.GetCustomerMakePaymentDetails(obj).subscribe((response: any) => {
        if (response && this.duplicateApiLeaseNo != response.PaymentResponses[0].LeaseNo && (response.PaymentResponses.find(o => o.Success === true) || count == maxTime)) {
          if (this.duplicateRequest) {
            this.duplicateRequest.unsubscribe();
            this.duplicateRequest = null;
          }
          this.duplicateApiLeaseNo = response.PaymentResponses[0].LeaseNo;
          if (count == maxTime && response.PaymentResponses.find(o => o.Success === false)) {
            this.toastr.warning('Duplicate Request Submitted. Please verify manually if your request has been completed', 'Alert', this.toasterConfig);
          }
          if (this.transferdataservice.pastdueautopay) {
            this.transferdataservice.pastdueautopay = null;
          }
          if (this.facOpsDataService.saveautopay && (this.facOpsDataService.saveautopay.Autopay || this.facOpsDataService.saveautopay.ACHPayment)) {
            this.getLettersAutoPay(this.facilityID, this.facOpsDataService.saveautopay.ACHPayment);
            this.facOpsDataService.saveautopay = null;
          }
          this.FingerprintpopupComponent.resetFingerprintOrigin();
          this.loaderIcon = Promise.resolve(false);
          let tempObj = response.PaymentResponses.find(o => o.Success === true);
          if (tempObj) {
            this.resObjDocument.push(tempObj);
            this.resObjDocument.map((item) => item['removeItem'] = false);
          }
          let resObj = response.PaymentResponses.find(o => o.Success === false);
          if (resObj) {
            this.receiptNumber = response.ReceiptNumber;
            this.responseFromApi = {
              ReceiptId: response.ReceiptNumber,
              Date: new Date(),
              Success: false,
              isErrorSection: false,
              AmountPaid: this.getAmountPaid(this.paymentDatailsObj)
            }
            if (type == 2) {
              // this.emitHideMakePay.emit(true);
              this.toastr.success('Failed to Save Allowance', 'Error', this.toasterConfig);
            } else {
              this.toastr.error('Failed to save payment', 'Error', this.toasterConfig);
            }
          } else {
            if (response.ReceiptNumber) {
              this.PayRecpNum = response.ReceiptNumber
            }
            let saveObj = this.facilityWiseMakePayList.find(o => o.FacilityId === this.processPayData.facId);
            if (saveObj) {
              saveObj.isPaid = true;
            }
            if (type == 2) {
              // this.emitHideMakePay.emit(true);
              this.toastr.success('Allowance saved successfully', 'Success', this.toasterConfig);
              this.cartOrderList = [];
              this.emitCartListOnUpdate.emit(this.cartOrderList);
              this.saveMakePaymentModel = [];
              if (this.refundService.lastAccessUnitData) {
                this.facilityID = this.refundService.lastAccessUnitData.FacilityId;
              }
              this.emitclosemakePay.emit(true);
              this.reloadcustomerinfo();
            } else {
              this.toastr.success('Payment Saved successfully', 'Success', this.toasterConfig);
            }

            this.receiptNumber = response.ReceiptNumber;
            this.responseFromApi = {
              ReceiptId: response.ReceiptNumber,
              Date: new Date(),
              ReceiptURL: response.ReceiptURL,
              Success: true,
              isErrorSection: false
            };
            this.clearCart()
          }
        }
      });
    } else {
      if (this.duplicateRequest) {
        this.duplicateRequest.unsubscribe();
        this.duplicateRequest = null;
      }
      this.loaderIcon = Promise.resolve(false);
      this.receiptNumber = 0;
      this.responseFromApi = {
        ReceiptId: 0,
        Date: new Date(),
        Success: false,
        AmountPaid: this.getAmountPaid(this.paymentDatailsObj),
      };
      this.toastr.warning('Duplicate Request Submitted. Please verify manually if your request has been completed', 'Alert', this.toasterConfig);
    }
  }

  reloadcustomerinfo() {
    if (this.resObjDocument.length) {
      if (this.isSaveAllowance) {
        this.cartOrderList = [];
        this.emitCartListOnUpdate.emit(this.cartOrderList);
        this.saveMakePaymentModel = [];
        this.facilityWiseMakePayList = [];
        this.hideCustomerSection.emit(false);
        this.DocumentViewPayment = false;
        this.cartTotal = 0;
        this.defaultDocList = [];
        this.defaultDocListPayment = [];
      } else {
        this.loopPayment();
      }
    } else {
      this.paymentSection = false;
      this.disableCartStyle = false;
      this.hideCustomerSection.emit(false);
      this.saveMakePaymentModel = [];
    }
  }

  emitFingerPrintSuccess(eve) {
    if (eve) {
      this.FingerprintpopupComponent.fingerPrintService.paymentOrigin = EPaymentOrigin.MakePayment;
    }
  }

  goToHostforPayment(val) {
    this.resObjDocument.find(o => o.LeaseNo === val).removeItem = true;
    let indexCart = this.resObjDocument.findIndex(o => o.LeaseNo === val);
    this.resObjDocument.splice(indexCart, 1);
    if (this.resObjDocument.length) {
      this.facilityIdPayment = this.resObjDocument[0].FacilityId;
      this.leaseNoPayment = this.resObjDocument[0].LeaseNo;
      let data = this.facilityWiseMakePayList.filter((item) => item.LeaseNo === this.leaseNoPayment);
      this.UnitNoPayment = data.SaveModelList.UnitNo;
      this.DocumentViewPayment = true;
    }
    this.DocumentViewPayment = true;
    this.NoentriesforLeaseAgreement = true;
    this.paymentSection = false;
    this.disableCartStyle = false;
    this.hideCustomerSection.emit(true);
  }

  goToHostPayment(data) {
    this.facilityWiseMakePayList.map((item) => {
      if (item.FacilityId === this.facilityIdPayment) {
        item.docProcessed = true;
      }
    });
    let index = this.facilityWiseMakePayList.findIndex(o => o.isPaid === false && o.docProcessed === false);
    if (index !== -1) {
      this.paymentSection = true;
      this.disableCartStyle = true;
      this.hideCustomerSection.emit(true);
      this.DocumentViewPayment = false;
      let unitDataList = [];
      this.facilityWiseMakePayList[index].SaveModelList.forEach((e) => {
        let PaymentDistributionOverride = e.PaymentDistributionOverride ? e.PaymentDistributionOverride : null
        if (PaymentDistributionOverride) {
          PaymentDistributionOverride['IsManualDistribution'] = true;
          PaymentDistributionOverride['IsAuctionProceed'] = false;
        }
        let unitDetails = {
          UnitId: e.UnitId,
          LeaseNo: e.LeaseNo,
          ReservationNo: null,
          UnitNo: e.UnitNo,
          Amount: e.AmountPaidTotal,
          PaymentDistribution: PaymentDistributionOverride
        }
        unitDataList.push(unitDetails);
      });
      this.processPayData.AmountTobePaid = this.facilityWiseMakePayList[index].FacilityTotalAmt;
      this.processPayData.AmountTobePaidWithoutPD = this.facilityWiseMakePayList[index].FacilityTotalAmtWithoutPD;
      this.processPayData.currentPeriodTotalAmount = this.facilityWiseMakePayList[index].FacilityTotalCurrentPeriodAmt;
      this.processPayData.TotalTax = this.commonMethod.roundToTwo(this.facilityWiseMakePayList[index].FacilityTotalTax || 0);
      this.processPayData.SurchargeFees = this.cartOrderList.find(o => o.UnitDetails.FacilityID === this.facilityWiseMakePayList[index].FacilityId)?.SurchargeFees ?? [];
      this.processPayData.facilityName = this.facilityWiseMakePayList[index].FacilityName;
      this.processPayData.facId = this.facilityWiseMakePayList[index].FacilityId;
      this.processPayData.TenantId = this.unitContactData.TenantId;
      this.processPayData.LeaseNo = this.unitContactData.LeaseNo;
      this.processPayData.UnitDetails = unitDataList;
      this.tenantAutoPayDetails = this.refundService.customerAutoPayDetails;
    } else {
      this.cartOrderList = [];
      this.emitCartListOnUpdate.emit(this.cartOrderList);
      this.saveMakePaymentModel = [];
      this.facilityWiseMakePayList = [];
      this.paymentSection = false;
      this.disableCartStyle = false;
      this.hideCustomerSection.emit(false);
      this.DocumentViewPayment = false;
      this.cartTotal = 0;
    }
    this.defaultDocList = [];
    this.defaultDocListPayment = [];
  }

  makePayNow(data) {
    if (data == 1) {    //Pay now
      this.openRentalPayment();
    } else if (data == 2) {
      this.loaderIcon = Promise.resolve(true);
      this.isSaveAllowance = true;
      this.processPayData.AmountTobePaid = 0;
      this.processPayData.AmountTobePaidWithoutPD = 0;
      this.responseFromApi = {};
      this.createMakePaymentSaveModel(data);
      let saveObj = this.facilityWiseMakePayList[0];
      if (saveObj && saveObj.SaveModelList[0]) {
        let payObj = {
          CashTransaction: null,
          CCTransaction: [],
          ACHTransaction: [],
          CheckTransaction: [],
          DirectDebitTransaction: [],
          IsRemotePayTransaction: false,
          RemotePayTransactionId: 0,
          RemotePayTransaction: null
        }
        saveObj.SaveModelList[0].PaymentModeDetails = payObj;
        this.saveMakePaymentDetails(saveObj.SaveModelList, data);
      }
    }
  }
}
